/*
 * @Author:马少博 (ma.shaobo@qq.com)
 * @Date: 拆分Router模块
 * @Last Modified by: 马少博
 * @Last Modified time:2018年8月21日16:54:07
 */
/* jshint esversion: 6 */

import WaterFall from './../components/WaterFall.vue';

export default [
    {
        path: "/water",
        name: "water",
        component: WaterFall
    }
]


// WEBPACK FOOTER //
// ./src/router/water.js